import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromWorkflow from '../store';
import { ObjectName } from '@view-model';
import { Observable } from 'rxjs';
import { createObjectSelector } from '../store';
import { tap } from 'rxjs/operators';
import { CompoundFilter } from '@cm/ui-modules';
import { FilterType } from '@cm/ui-modules';

@Injectable({ providedIn: 'root' })
export class ObjectService {
  private store = inject<Store<fromWorkflow.State>>(Store);

  getObject(objectName: ObjectName, id: string): Observable<any> {
    return this.store.pipe(
      select(createObjectSelector(objectName, id)),
      tap((data) => {
        if (!data) {
          const compoundFilter: CompoundFilter = {
            type: FilterType.FILTER,
            filter: {
              objectName,
              objectField: 'id',
              operator: 'EQUALS',
              value: id,
            },
          };
          this.store.dispatch(
            new fromWorkflow.FilterObjectList({
              objectName,
              compoundFilter,
            }),
          );
        }
      }),
    );
  }
}
